import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";

import BusinessConstraints from "components/Business/Strategy/BusinessConstraints";
import NextBusinessConstraints from "components/Business/Strategy/BusinessConstraints";

class BusinessConstraintsContainer extends React.PureComponent {
  render() {
    return this.props.isNext ? <NextBusinessConstraints {...this.props} /> : <BusinessConstraints {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = ownProps.id;

  return {
    resetBusinessConstraints: (runId) => dispatch(setupReducer.resetBusinessConstraints(id, runId)),

    updatePrimaryBusinessConstraintType: (runId, primaryConstraintType) =>
      dispatch(setupReducer.updatePrimaryBusinessConstraintType(id, runId, primaryConstraintType)),

    updateSecondaryBusinessConstraintType: (runId, secondaryConstraintType) =>
      dispatch(setupReducer.updateSecondaryBusinessConstraintType(id, runId, secondaryConstraintType)),

    updateBusinessConstraintMode: (runId, type, mode) =>
      dispatch(setupReducer.updateBusinessConstraintMode(id, runId, type, mode)),

    updateBusinessConstraintDirection: (runId, type, direction) =>
      dispatch(setupReducer.updateBusinessConstraintDirection(id, runId, type, direction)),

    updateBusinessConstraintValue: (runId, type, value) =>
      dispatch(setupReducer.updateBusinessConstraintValue(id, runId, type, value))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;

  let optimized = ownProps.optimized;
  if (!optimized || optimized.id !== id) {
    optimized = projectReducer.getOptimized(state, id);
  }

  let modelGroups = ownProps.modelGroups;
  if (!modelGroups || modelGroups.id !== id) {
    modelGroups = projectReducer.getModelGroups(state, id);
  }

  const runId = optimized && optimized.innerId !== undefined ? optimized.innerId : id;

  return {
    id: id,
    runId: runId,
    optimized: optimized,
    modelGroups: modelGroups,

    hasCustomMappings: setupReducer.getProjectHasCustomMappings(state, id),

    costLabel: setupReducer.getAdvancedCostLabel(state, runId),
    revenueLabel: setupReducer.getAdvancedRevenueLabel(state, runId),
    profitLabel: setupReducer.getNetImpactLabel(state, runId),
    setupLabels: setupReducer.getSetupLabels(state, runId),
    setup: setupReducer.getSetup(state, runId),
    overallBusinessConstraints: setupReducer.getOverallBusinessConstraints(state, id),
    primaryConstraint: setupReducer.getPrimaryBusinessConstraint(state, id, runId),
    secondaryConstraint: setupReducer.getSecondaryBusinessConstraint(state, id, runId),
    primaryBusinessConstraintType: setupReducer.getPrimaryBusinessConstraintType(state, id, runId),
    secondaryBusinessConstraintType: setupReducer.getSecondaryBusinessConstraintType(state, id, runId),
    allBusinessConstraints: setupReducer.getAllBusinessConstraints(state, id),

    isOptimizerWithinBounds: projectReducer.getOptimizerWithinBounds(state, id),
    isOverallSegment: projectReducer.getIsOverallSegment(state, id, runId, true)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(BusinessConstraintsContainer);
